<template>
    <div class="Editor">
        <h3>{{ this.$store.getters.getCentro?.Descrizione }}</h3>
        <p>{{ this.$store.getters.getCentro?.DescrizioneEstesa }}</p>
    </div>
</template>

<script>


export default{
    name: "BookingDescription",
      
}
</script>
